const uploadMealPopUpTranslations = {
  title: "Upload Your Meal",
  description: "Upload a photo of your meal",
  actionButtons: {
    submit: "Submit",
    decline: "Don't Upload Meal",
  },
};

export default uploadMealPopUpTranslations;
